import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

import { infoModalRowClick, isOpenInfo } from "../@signals"


export default function CommonIconButton({ alertSelected, ...props }) {

    const onClick = () => batch(() => {
        infoModalRowClick.value = alertSelected
        isOpenInfo.value = true
    })

    return <Box onClick={onClick}>
        <ButtonIconSeeker 
            size="small"
            icon="circle-info"
            tooltip="To see additional information, click on this icon"
            {...props}
        />
    </Box>
}